import {
  Card,
  buttonBaseClasses,
  cardActionAreaClasses,
  cardActionsClasses,
  cardContentClasses,
  styled,
} from "@mui/material";

export const CardStyled = styled(Card)(({ theme: { palette, spacing } }) => ({
  transition: "0.5s all",
  height: "100%",
  display: "flex",
  "&:hover": {
    boxShadow: "0px 3px 11px 0px rgba(0,0,0,0.2)",
  },
  [`.${cardActionAreaClasses.root}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  [`.${cardActionAreaClasses.root}:hover`]: {
    [`& .${cardActionAreaClasses.focusHighlight}`]: {
      opacity: 0,
    },
    [`& .${buttonBaseClasses.root}`]: {
      backgroundColor: palette.grey[800],
    },
  },
  [`& .${cardContentClasses.root}`]: {
    paddingBottom: 0,
    marginBottom: `-${spacing(4)}`,
    width: "100%",
  },
  [`& .${cardActionsClasses.root}`]: {
    padding: spacing(3),
  },
}));
